const typeMap = {
  '~': '修改',
  '-': '删除',
  '+': '新增',
};
export default () => [
  {
    title: '操作人',
    dataIndex: 'history_staff_name',
    key: 'history_staff_name',
    width: 90,
  },
  {
    title: '操作时间',
    dataIndex: 'history_date',
    key: 'history_date',
    width: 200,
  },
  {
    title: '数据标题',
    dataIndex: 'history_title',
    key: 'history_title',
  },
  {
    title: '操作类型',
    dataIndex: 'history_type',
    key: 'history_type',
    width: 90,
    render: t => typeMap[(t || '').toLowerCase()],
  },
  {
    title: '操作详情',
    dataIndex: 'detail',
    key: 'detail',
  },
];
